import { css } from "@vitality-ds/system";
export default css({
  display: "flex",
  alignItems: "center",
  gap: "$md",
  flexWrap: "wrap",
  alignSelf: "flex-end"
});